import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { ModalWithNavComponent } from '@shared/components/modal-with-nav/modal-with-nav.component';
import { ModalService } from '@shared/services/modal/modal.service';
import { DivisionalPromotionFilterType } from '../models/seller-showcase.model';
import { SellerShowcaseFiltersDesktopTabletComponent } from '../components/seller-showcase-filters/seller-showcase-filters-desktop-tablet/seller-showcase-filters-desktop-tablet.component';
import { SellerShowcaseFiltersMobileComponent } from '../components/seller-showcase-filters/seller-showcase-filters-mobile/seller-showcase-filters-mobile.component';

@Injectable({
  providedIn: 'root',
})
export class SellerShowcaseOverlayService {
  constructor(
    readonly platformService: PlatformService,
    private modalCtrl: ModalController,
    private modalService: ModalService,
  ) {}

  async openSortModal(
    brandsNames: string[],
    promoTypes: string[],
    exclusiveBrandValues: string[],
    productClasses: string[],
    selectedFilters: Map<DivisionalPromotionFilterType, string>,
  ) {
    this.modalService.setModalOptions(
      this.platformService.isTouch.value,
      ModalWithNavComponent,
      {
        rootPage:
          this.platformService.platformType ===
          this.platformService.platformEnum.mobile
            ? SellerShowcaseFiltersMobileComponent
            : SellerShowcaseFiltersDesktopTabletComponent,
        rootPageParams: {
          brandsNames,
          promoTypes,
          exclusiveBrandValues,
          productClasses,
          selectedFilters,
        },
      },
      'modal-desktop-size-xl',
    );

    const modal = await this.modalCtrl.create(this.modalService.modalOptions);
    await modal.present();
    return modal;
  }
}
